import styles from './TriggerButton.module.css';

interface TriggerButtonProps {
  onClick: () => void;
  label?: string;
}

export function TriggerButton({
  onClick,
  label = 'Jetzt buchen',
}: TriggerButtonProps) {
  return (
    <button type="button" className={styles.trigger} onClick={onClick}>
      {label}
    </button>
  );
}
